'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-show.routes';

export class SurveyShowComponent {
  constructor(Auth, SurveysService, SurveyResultsService, dialogs, $uibModal, $stateParams, $scope, Config, User) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;
    this.User = User;
    this.$scope = $scope;

    Auth.getCurrentUser(user => {

      User.getResidencies({id: user._id}, res => {

        this.userRoles = user.role;
        this.userResidencyRelations = res.residencyRelations;

        this.model = {};
        this.surveyId = $stateParams.id;
        this.surveyResult = {
          survey: this.surveyId,
          meta: {
            creationUser: user._id
          }
        };

        this.dialogs = dialogs;
        this.$uibModal = $uibModal;

        this.formName = $stateParams.name;

        this.SurveysService.get({id: this.surveyId}, (survey) => {
          this.survey = survey;

          this.galleryImages = survey.attachments
            .filter(attachment => this.isImageMime(attachment.contentType))
            .map(obj => {
              var rObj = {};

              rObj.title = obj.filename;
              rObj.alt = obj.filename;
              rObj.url = "/api/storage/" + obj._id;
              rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

              return rObj;
            });

          if (this.survey.settings.onlyCertainRoles) {
            this.userResidencyRelations = this.userResidencyRelations.filter(rr => this.survey.settings.roles.includes(rr.type));
          }
          
          this.allowed = true;

          /* Check status */
          if (this.survey.status == 'closed') {
            this.allowed = false;
            this.closed = true;
          } else if (this.survey.status == 'draft' && !this.isAdmin()) {
            this.allowed = false;
            this.draft = true;
          }

          /* Check permissions by role */
          if (this.survey.settings.onlyCertainRoles && !this.isAdmin()) {
            if (!this.survey.settings.roles.some(role => this.userRoles.includes(role))) {
              this.allowed = false;
              this.noPermission = true;
            }
          }

          /* Check already taken by user */
          if (this.survey.settings.restriction == 'user') {

            User.getResidencies({id: this.userId}, res => {
              this.residencyRelations = res.residencyRelations;
            });

            this.SurveyResultsService.getSurveyResultByUser({
              user: user._id,
              survey: this.surveyId
            }, surveyResult => {

              if (surveyResult) {
                this.surveyResult = surveyResult;
                this.model = this.surveyResult.answers;

                this.alreadyTaken = true;

                if (!this.survey.settings.canBeChanged) {
                  this.allowed = false;
                }
              }
            }, err => console.log(err));
          }

          if (this.survey.settings.restriction == 'unit') {

            if (!this.userResidencyRelations || !this.userResidencyRelations.length) {
              this.allowed = false;
              this.noPermission = true;
            } else {
              let max_done = this.userResidencyRelations.length;
              let done = 0;

              let finalize_check = _ => {
                this.allowedResidencyRelations = this.userResidencyRelations.filter(rr => !rr.taken);
                this.selectedResidencyRelations = this.allowedResidencyRelations.map(_ => true);  // preselect for all possible rr
                if (!this.allowedResidencyRelations.length) {
                  this.alreadyTakenUnit = true;
                  this.allowed = false;
                }
              };

              this.userResidencyRelations.forEach(rr => {
                this.SurveyResultsService.getSurveyResultByBuildingAndUnit({
                  building: rr.building || '-',
                  unit: rr.unit,
                  survey: this.surveyId}, surveyResult => {

                  rr.taken = true;

                  done++;
                  if (max_done == done) {
                    finalize_check();
                  }
                }, _ => {
                  done++;
                  if (max_done == done) {
                    finalize_check();
                  }
                });
              });
            }

            /*
            this.SurveyResultsService.getSurveyResultByBuildingAndUnit({
              user: user._id,
              survey: this.surveyId}, surveyResult => {

              if (surveyResult) {
                this.surveyResult = surveyResult;
                this.model = this.surveyResult.answers;

                this.alreadyTaken = true;

                if (!this.survey.settings.canBeChanged) {
                  this.allowed = false;
                }
              }
            }, err => console.log(err));
            */
          }

          let schema = {
            "type": "object",
            "properties": {},
            "required": []
          };

          let form = [];

          for (let i = 0; i < survey.questions.length; i++) {
            let key = "question_" + i;

            if (survey.questions[i].required) {
              schema.required.push(key);
            }

            switch (survey.questions[i].type) {
              case 'text':
                schema.properties[key] = {
                  "title": survey.questions[i].question,
                  "type": "string"
                };
                break;
              case 'select-one':
                schema.properties[key] = {
                  "title": survey.questions[i].question,
                  "type": "string",
                  enum: survey.questions[i].answers
                };
                break;
              case 'select-many':
                schema.properties[key] = {
                  "title": survey.questions[i].question,
                  "type": "array",
                  "items": {
                    enum: survey.questions[i].answers
                  }
                };
                break;
            }
            form.push(key);
          }

          this.schema = schema;
          this.form = form;
        }, err => {
          console.log("Could not retrieve survey from server.")
        })

      });
    });
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The survey has been sent successfully");
        dlg.result.then(() => {
          that.sendSuccess = true;
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.surveyResult.answers = this.model;

      if (this.survey.settings.restriction == 'unit') {
        let selectedRRs = this.allowedResidencyRelations.filter((rr, idx) => this.selectedResidencyRelations[idx]);

        selectedRRs.forEach(rr => {
          let surveyData = angular.copy(this.surveyResult);
          surveyData.meta.building = rr.building || '-';
          surveyData.meta.unit = rr.unit;

          this.SurveyResultsService.save(surveyData, _=> {}, onError);
        });

        onSuccess();
      } else {
        if (this.surveyResult._id) {
          this.SurveyResultsService.update(this.surveyResult._id, this.surveyResult, onSuccess, onError)
        } else {
          this.SurveyResultsService.save(this.surveyResult, onSuccess, onError);
        }
      }
    }
  }
}

export default angular.module('conduu.surveyShow', [uiRouter])
  .config(routes)
  .component('surveyShow', {
    template: require('./survey-show.html'),
    controller: SurveyShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/show/survey-show.component.js